import { createGlobalStyle } from 'styled-components';
import { breakpoints, colors } from '../constants';

export const GlobalStyle = createGlobalStyle`
@font-face {
        font-family: 'Clan';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3-eu-central-1.amazonaws.com/gon/assets/fonts/ClanOT_400.otf');
    }

    @font-face {
        font-family: 'Clan';
        font-weight: 500;
        font-style: normal;
        src: url('https://grandvision.s3-eu-central-1.amazonaws.com/gon/assets/fonts/ClanOT_500.otf');
    }


    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Clan', Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 0;
        max-width: 768px;
        margin: 0 auto;
        font-size: 1rem;
    }

    h1, h2, h3, h4, p {
        margin: 0;
    }

    h3, p {
        line-height: 1.4;

        @media (${breakpoints.mediumMin}) {
            line-height: 1.5;
        }
    }

    h3 {
        font-size: 1.1rem;
        font-weight: 300;

        @media (${breakpoints.mediumMin}) {
            font-size: 1.2rem;
        }
    }

    h4 {
        line-height: 1.3;
    }

    button {
        font-family: 'Clan', sans-serif;
    }

    a {
        color: ${colors.black};
    }
`;
